<mat-form-field [appearance]="appearance" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="false"
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="autocompleteControl"
    [required]="required"
    (keyup)="onKeyup()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (opened)="onDropdownOpen()"
    (closed)="onDropdownClose()"
  >
    @if (optGroup.title !== null) {
    <mat-optgroup [label]="optGroup.title ? optGroup.title : ''">
      @for (option of optGroup.list; track $index) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
      }
    </mat-optgroup>
    } @if (optGroup.title !== null) {
    <mat-optgroup label="All">
      @for (option of filteredOptions$ | async; track option.name) {
      <mat-option [value]="option.name" [disabled]="option.disabled">
        {{ option.name }}
      </mat-option>
      }
    </mat-optgroup>
    } @else { @for (option of filteredOptions$ | async; track $index+100) {
    <mat-option [value]="option.name" [disabled]="option.disabled">
      {{ option.name }}
    </mat-option>
    } }
  </mat-autocomplete>
</mat-form-field>
